<template>
    <div id="computer" class="min-h-screen bg-slate-50">
        <topBox :title="title" />
        <div class="px-4 w-full pt-[44px] pb-[65px] mt-[44px] mb-[55px] mx-auto overflow-y-auto">

            <!-- 页面标题区 -->
            <header class="mb-8 px-1">
                <h2 class="text-xl font-bold text-slate-800 tracking-tight">发布视频</h2>
                <p class="mt-2 text-sm text-slate-400 leading-relaxed">填写视频信息与收费设置，提交后等待平台审核</p>
            </header>

            <div class="space-y-5">

                <!-- 文章标题 -->
                <section class="rounded-2xl bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:shadow-md">
                    <label class="mb-3 flex items-center gap-2 text-sm font-bold text-slate-800">
                        <svg class="h-4 w-4 shrink-0 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                        </svg>
                        文章标题
                    </label>
                    <p class="mb-3 text-right text-sm text-rose-600" v-show="err.title">{{ msg.errTitle }}</p>
                    <input
                        name="title"
                        type="text"
                        class="block w-full rounded-xl border-0 bg-slate-50 px-4 py-3 text-sm text-slate-800 placeholder:text-slate-400 outline-none ring-1 ring-slate-200/80 transition-all duration-300 ease-in-out focus:bg-white focus:ring-2 focus:ring-indigo-500/30 focus:shadow-[0_0_0_4px_rgba(99,102,241,0.08)]"
                        :placeholder="msg.title"
                        v-model="form.title"
                    />
                </section>

                <!-- 上传封面 -->
                <section class="rounded-2xl bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:shadow-md">
                    <label class="mb-3 flex items-center gap-2 text-sm font-bold text-slate-800">
                        <svg class="h-4 w-4 shrink-0 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                        </svg>
                        上传封面
                    </label>
                    <p class="mb-3 text-right text-sm text-slate-400" v-show="err.image">{{ err.image }}</p>
                    <p class="mb-3 text-right text-sm text-rose-600" v-show="err.image">{{ err.image }}</p>
                    <label class="group flex cursor-pointer items-center gap-3 rounded-xl bg-slate-50 px-4 py-3 ring-1 ring-slate-200/80 transition-all duration-300 ease-in-out hover:bg-slate-100/80 focus-within:bg-white focus-within:ring-2 focus-within:ring-indigo-500/30 focus-within:shadow-[0_0_0_4px_rgba(99,102,241,0.08)]">
                        <svg class="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-300 group-hover:text-indigo-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
                        </svg>
                        <span class="text-sm text-slate-400">点击选择封面图片</span>
                        <input
                            name="icon"
                            type="file"
                            @change="selectCover"
                            class="sr-only"
                        />
                    </label>
                    <p class="mt-3 flex items-center gap-2 text-sm text-emerald-600" v-if="uploadCover">
                        <svg class="h-4 w-4 shrink-0 animate-spin" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                        </svg>
                        {{ uploadCoverText }}
                    </p>
                </section>

                <!-- 收费金额 -->
                <section class="rounded-2xl bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:shadow-md">
                    <label class="mb-3 flex items-center gap-2 text-sm font-bold text-slate-800">
                        <svg class="h-4 w-4 shrink-0 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        收费金额
                    </label>
                    <p class="mb-3 text-right text-sm text-rose-600" v-show="err.amount">{{ msg.errTitle }}</p>
                    <input
                        name="amount"
                        type="text"
                        class="block w-full rounded-xl border-0 bg-slate-50 px-4 py-3 text-sm text-slate-800 placeholder:text-slate-400 outline-none ring-1 ring-slate-200/80 transition-all duration-300 ease-in-out focus:bg-white focus:ring-2 focus:ring-indigo-500/30 focus:shadow-[0_0_0_4px_rgba(99,102,241,0.08)]"
                        :placeholder="msg.amount"
                        v-model="form.amount"
                    />
                    <p class="mt-3 text-sm text-slate-400 leading-relaxed">如果不设置金额，视频将免费提供给用户观看</p>
                </section>

                <!-- 上传视频 -->
                <section class="rounded-2xl bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:shadow-md">
                    <label class="mb-3 flex items-center gap-2 text-sm font-bold text-slate-800">
                        <svg class="h-4 w-4 shrink-0 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z" />
                        </svg>
                        上传视频
                    </label>
                    <p class="mb-3 text-right text-sm text-slate-400" v-show="err.video">{{ err.video }}</p>
                    <p class="mb-3 text-right text-sm text-rose-600" v-show="err.video">{{ err.video }}</p>
                    <label class="group flex cursor-pointer items-center gap-3 rounded-xl bg-slate-50 px-4 py-3 ring-1 ring-slate-200/80 transition-all duration-300 ease-in-out hover:bg-slate-100/80 focus-within:bg-white focus-within:ring-2 focus-within:ring-indigo-500/30 focus-within:shadow-[0_0_0_4px_rgba(99,102,241,0.08)]">
                        <svg class="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-300 group-hover:text-indigo-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
                        </svg>
                        <span class="text-sm text-slate-400">点击选择视频文件</span>
                        <input
                            name="icon"
                            type="file"
                            @change="selectVideo"
                            class="sr-only"
                        />
                    </label>
                    <p class="mt-3 flex items-center gap-2 text-sm text-emerald-600" v-if="uploadVideo">
                        <svg class="h-4 w-4 shrink-0 animate-spin" aria-hidden="true" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                        </svg>
                        {{ uploadVideoText }}
                    </p>
                </section>

                <!-- 收费时间 -->
                <section class="rounded-2xl bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:shadow-md">
                    <label class="mb-3 flex items-center gap-2 text-sm font-bold text-slate-800">
                        <svg class="h-4 w-4 shrink-0 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        收费时间
                    </label>
                    <p class="mb-3 text-right text-sm text-rose-600" v-show="err.second">{{ msg.errSecond }}</p>
                    <input
                        name="title"
                        type="text"
                        class="block w-full rounded-xl border-0 bg-slate-50 px-4 py-3 text-sm text-slate-800 placeholder:text-slate-400 outline-none ring-1 ring-slate-200/80 transition-all duration-300 ease-in-out focus:bg-white focus:ring-2 focus:ring-indigo-500/30 focus:shadow-[0_0_0_4px_rgba(99,102,241,0.08)]"
                        :placeholder="msg.tipSecond"
                        v-model="form.second"
                    />
                    <p class="mt-3 text-sm text-slate-400 leading-relaxed">0.5 表示开始前半分钟内不收费</p>
                </section>

                <!-- 提交按钮 -->
                <div class="pt-2 pb-4">
                    <button
                        type="button"
                        class="flex w-full items-center justify-center gap-2 rounded-xl bg-indigo-600 px-6 py-4 text-sm font-bold text-white shadow-[0_8px_30px_rgb(99,102,241,0.25)] transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:bg-indigo-700 hover:shadow-[0_12px_40px_rgb(99,102,241,0.35)] active:translate-y-0 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:ring-offset-2"
                        @click="runSubmit"
                    >
                        <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                        </svg>
                        {{ $t('but.continue') }}
                    </button>
                </div>

            </div>
        </div>

        <mainMenu />

        <!-- 成功发布的模态提示 -->
        <Transition
            enter-active-class="transition-opacity duration-300 ease-out"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity duration-200 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div v-if="successModalVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 px-4 backdrop-blur-sm">
                <Transition
                    enter-active-class="transition-all duration-300 ease-out"
                    enter-from-class="opacity-0 scale-95 translate-y-2"
                    enter-to-class="opacity-100 scale-100 translate-y-0"
                    leave-active-class="transition-all duration-200 ease-in"
                    leave-from-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-95"
                >
                    <div v-if="successModalVisible" class="w-full max-w-[340px] rounded-2xl bg-white p-8 text-center shadow-[0_20px_60px_rgb(0,0,0,0.12)]">
                        <div class="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50">
                            <svg class="h-7 w-7 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <h3 class="mb-2 text-lg font-bold text-slate-800">成功发布</h3>
                        <p class="mb-6 text-sm leading-relaxed text-slate-400">
                            等待平台审核。<span class="font-bold text-indigo-600">{{ successCountdown }}</span> 秒后返回用户中心。
                        </p>
                        <div class="flex justify-center gap-3">
                            <button
                                @click="immediateReturn"
                                class="rounded-xl bg-indigo-600 px-5 py-2.5 text-sm font-bold text-white transition-all duration-300 ease-in-out hover:bg-indigo-700 hover:shadow-md"
                            >
                                立即返回
                            </button>
                            <button
                                @click="closeSuccessModal"
                                class="rounded-xl bg-slate-100 px-5 py-2.5 text-sm font-bold text-slate-600 transition-all duration-300 ease-in-out hover:bg-slate-200"
                            >
                                关闭
                            </button>
                        </div>
                    </div>
                </Transition>
            </div>
        </Transition>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import topBox from "@/components/computer/TopBox.vue"
import mainMenu from "@/components/computer/MainMenu.vue"
import axios from 'axios'
import { layer } from "vue3-layer"
// 不用编辑器就不要加载 01
// import { QuillEditor } from '@vueup/vue-quill'
// import '@vueup/vue-quill/dist/vue-quill.snow.css'
export default {
    components: {
        topBox,
        mainMenu,
        // QuillEditor, 不用编辑器就不要加载 02
    },
    setup() {
        // console.log( `token : ${localStorage.getItem('token')}` )
        // if ( !localStorage.getItem('token') ) {
        //     console.log('连令牌都没有，还不去登录？')
        // }
    },
    data() {
        return {
            title: this.$t('page.PublishArticle'),
            lang: '',
            api: {
                account: null,
                uid: 0,
                invite: null,
                bank_id: null,
            },
            err: {
                title: false,
                amount: false,
                image: false,
                video: false,
                second: false,
            },
            tip: {
                title: false,
                amount: false,
                image: false,
                video: false,
                second: false,
            },
            msg: {
                errSort_id: '必须选择',
                tipTitle: '请输入中文的商品分类名称',
                errTitle: '',
                tipTitle_vi: '请输入越文的商品分类名称',
                errTitle_vi: '',
                tipShop: '请输入中文的店铺名称',
                errShop: '',
                tipShop_vi: '请输入越文的店铺名称',
                errShop_vi: '',
                tipPrice: '请输入商品的价格',
                errPrice: '',
                tipIcon: '请选择分类的LOGO',
                errIcon: '',
                tipSecond: '第几分钟开始收费',
                errSecond: '',
            },
            editor: '',
            form: {
                title: '',
                editor: '',  // 文章正文 因为用了编辑器插件
                pay: '',     // 文章正文 该部份为付费部份
                amount: 0,  // 收费金额
                cover: '',   // 视频的封面图
                video: '',
                second: 0.5,  // 在哪个单位开始收费 30 秒一个单位
            },
            uploadCover: false, // uploadCover 控制是否显示上传封面的进度条
            uploadCoverText: '封面图正在上传，请稍候...',
            uploadVideo: false,
            uploadVideoText: '视频正在上传，请稍候...',
            // 倒计时相关
            successCountdown: 0,
            successTimer: null,
            successModalVisible: false,
        }
    },
    mounted() {
        // 切换语言
        const { locale } = useI18n()  // 从国际化中取出配置项 locale 因为初始化时 用户没有指定语种 要使用系统默认的语种
        this.lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : locale.value // 如果用户有选择特定语种 就使用用户指定的 不然就使用系统默认的
        locale.value = this.lang
        // 通过 Token 去调取帐号相关信息，即时。
        this.getInfo()
        return {}
    },
    methods: {
        selectCover(event) {
            this.form.cover = event.target.files[0]
        },
        selectVideo(event)
        {
            this.form.video = event.target.files[0]
        },
        doClick() {
            // console.log('ok')
        },
        onSubmit() {
            this.$route.to('/recharge')
        },
        // 得到这个用户的基本信息
        getInfo()
        {
            // console.log('得到这个用户的基本信息')
            axios.post(
                '/api/m/info/user', 
                {
                },
                {
                    headers: {
                        // 'Content-Type': 'multipart/form-data'
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token')
                    }
                }
            )
            .then((response) =>  {
                // console.log(response.data)
                if (0===response.data.code) {
                    this.api.bank_id = response.data.data.bank_id
                    this.api.account = response.data.data.account
                    this.api.grade = `VIP${response.data.data.grade}` 
                    this.api.uid = response.data.data.uid
                    this.api.invite = response.data.data.uuid
                    this.api.balance = response.data.data.balance
                    this.api.frozen = response.data.data.frozen
                } else {
                    // let word = response.data.data.id
                    // let key = word.charAt(0).toUpperCase() + word.slice(1)
                    // // 转成国际化 后端转提示语 前端转表单名称
                    // let msg = this.$t(`input.${key}`) + ' ' + response.data.msg 
                    layer.msg(response.data.msg)
                }
            })
            .catch(function (error) {
                console.log(error)
            })
        },
        // End 得到这个用户的基本信息
        out() {
            // localStorage.removeItem('token')
            axios.post(
                '/api/m/out', 
                {

                },
                {
                    headers: {
                        // 'Content-Type': 'multipart/form-data'
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token')
                    }
                }
            )
            .then((response) =>  {
                if (0===response.data.code) {
                    localStorage.removeItem('token')
                    // this.$router.go(0) // 刷新本页
                    // 跳转
                    this.$router.push({
                        path: '/computer/login',
                        query: {
                            msg: 'account out'
                        }
                    })
                } else {
                    layer.msg( response.data.msg )
                }
            })
            .catch(function (error) {
                console.log(error)
            })
        }, // End out() 退出系统
        // 提交视频及附属信息
        runSubmit() {
            console.log('提交视频及附属信息')

            axios.post(
                '/api/m/video', 
                {
                    cover: this.form.cover,
                    video: this.form.video,
                    title: this.form.title,
                    amount: this.form.amount,
                    second: this.form.second,
                },
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',  // multipart/form-data，以支持文件上传
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token')
                    },
                    // 使用onUploadProgress方法来监听上传进度事件 并将进度以百分比的形式存储在uploadProgress属性中
                    onUploadProgress: () => {
                        this.uploadCover = true
                        this.uploadVideo = true
                    },
                }
            )
            .then((response) =>  {
                if (0===response.data.code) {
                    this.uploadCover = false
                    this.uploadVideo = false
                    // 发布成功：显示页面内模态并开始 10 秒倒计时，倒计时结束后跳回用户中心
                    // 清理可能存在的定时器
                    if (this.successTimer) {
                        clearInterval(this.successTimer)
                        this.successTimer = null
                    }
                    this.successCountdown = 10
                    this.successModalVisible = true
                    // 每秒倒计时
                    this.successTimer = setInterval(() => {
                        this.successCountdown -= 1
                        if (this.successCountdown <= 0) {
                            clearInterval(this.successTimer)
                            this.successTimer = null
                            this.successModalVisible = false
                            this.$router.push({ path: '/computer/user' })
                        }
                    }, 1000)
                } else {
                    // layer 弹窗的颜色与透明度
                    layer.msg( response.data.msg )
                }
            })
            .catch(function (error) {
                console.log(error)
            })
        }, // End runSubmit() 提交视频及附属信息
        immediateReturn() {
            // 立即返回用户中心并清理定时器
            if (this.successTimer) {
                clearInterval(this.successTimer)
                this.successTimer = null
            }
            this.successModalVisible = false
            this.$router.push({ path: '/computer/user' })
        },
        closeSuccessModal() {
            // 关闭模态但保持倒计时进行（或可选择停止倒计时）
            if (this.successTimer) {
                clearInterval(this.successTimer)
                this.successTimer = null
            }
            this.successModalVisible = false
        },
    },
    // 在组件销毁时清理定时器
    beforeUnmount() {
        if (this.successTimer) {
            clearInterval(this.successTimer)
            this.successTimer = null
        }
    }
}
</script>

<style>
.focus {
    /* background-image: url('/public/upload/600.png'); */
    background-repeat: no-repeat; /** 图片不要平铺 */
    background-size: 100% 190px; /** 因为用大一倍的图，才够清晰，但是如果不定义自适应，只能显示一半的图片。所以宽度给 100% 但高度要给它限制 */
}
.ql-toolbar {
    @apply p-[1px];
    height: auto;
    font-size: 12px;
}
.layui-layer-content{background-color:  #c00; color: #fff;}
</style>